import { io } from "socket.io-client";
import { SOCKET_ORIGIN, WS_PATH } from "./backend-config";

let _socket: ReturnType<typeof io> | null = null;

export function getSocket(): ReturnType<typeof io> {
  // Echtes Singleton: NICHT neu erzeugen, nur weil die Verbindung noch im Aufbau
  // ist. socket.io puffert Emits bis zum Connect und reconnektet selbst. Würde man
  // bei `!connected` neu erzeugen, bekämen parallele Aufrufer beim Start je eine
  // eigene Socket-Instanz — auth_token und model_list landeten auf verschiedenen
  // Sockets, und der per socket.id gehaltene Auth-Context fehlte (→ auth_required).
  if (!_socket) {
    _socket = io(`${SOCKET_ORIGIN}/session`, { transports: ["websocket"], path: WS_PATH });
  }
  return _socket;
}
